module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet box blue"
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: "fa fa-cutlery",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Refeições")])])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('div', {
    staticClass: "table-responsible"
  }, [_c('table', {
    staticClass: "table table-striped table-bordered table-hover m-b-0 text-center"
  }, [_c('thead', [_c('tr', [_c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "text-center"
  }, [_vm._v("Horário")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "text-center"
  }, [_vm._v("Alimento")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "text-center"
  }, [_vm._v("Quantidade")])])]), _vm._v(" "), _c('tbody', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.meals),
      expression: "meals"
    }]
  }, [_vm._l((_vm.meals), function(meal, index) {
    return [_c('tr', [_c('td', {
      staticClass: "align-middle",
      attrs: {
        "rowspan": "2"
      }
    }, [(meal.time.time) ? _c('p', [_vm._v(_vm._s(_vm._f("date")(meal.time.time, 'HH:mm', true)))]) : _vm._e(), _vm._v(" "), (!meal.time.time) ? _c('p', [_vm._v("-")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (meal.time.meal),
        expression: "meal.time.meal"
      }],
      domProps: {
        "innerHTML": _vm._s(_vm.$options.filters.linebreak(meal.time.meal, ', '))
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!meal.time.meal),
        expression: "!meal.time.meal"
      }, {
        name: "translate",
        rawName: "v-translate"
      }]
    }, [_vm._v("Não informado")])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "mt-radio-inline"
    }, _vm._l((_vm.quantityTypes), function(value, key) {
      return _c('label', {
        staticClass: "mt-radio mt-radio-outline",
        class: {
          'mt-radio-disabled': !meal.time.meal
        }
      }, [_c('input', {
        attrs: {
          "type": "radio",
          "name": 'meal-portion-' + index,
          "data-index": index,
          "disabled": !meal.time.meal
        },
        domProps: {
          "value": key,
          "checked": _vm.meals[index].mealPortion === key
        },
        on: {
          "change": _vm.putAgendaMealPortion
        }
      }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(value) + "\n\t\t\t\t\t\t\t\t\t\t"), _c('span')])
    }))])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (meal.time.beverage),
        expression: "meal.time.beverage"
      }],
      domProps: {
        "innerHTML": _vm._s(_vm.$options.filters.linebreak(meal.time.beverage, ', '))
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!meal.time.beverage),
        expression: "!meal.time.beverage"
      }, {
        name: "translate",
        rawName: "v-translate"
      }]
    }, [_vm._v("Não informado")])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "mt-radio-inline"
    }, _vm._l((_vm.quantityTypes), function(value, key) {
      return _c('label', {
        staticClass: "mt-radio mt-radio-outline",
        class: {
          'mt-radio-disabled': !meal.time.beverage
        }
      }, [_c('input', {
        attrs: {
          "type": "radio",
          "name": 'beverage-portion-' + index,
          "data-index": index,
          "disabled": !meal.time.beverage
        },
        domProps: {
          "value": key,
          "checked": _vm.meals[index].beveragePortion === key
        },
        on: {
          "change": _vm.putAgendaBeveragePortion
        }
      }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(value) + "\n\t\t\t\t\t\t\t\t\t\t"), _c('span')])
    }))])])]
  })], 2), _vm._v(" "), _c('tfoot', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.meals || !_vm.meals.length),
      expression: "!meals || !meals.length"
    }]
  }, [_c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Não há refeição registrada para este aluno")])])])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h5', [_c('strong', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "font-blue"
  }, [_vm._v("Alimentos Adicionais")])]), _vm._v(" "), _c('form', {
    staticClass: "row additional-meals",
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.addAdditionalMealsItem($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group col-md-2 col-xs-3",
    class: {
      'has-error': _vm.errors.has('additionalmeal-time')
    }
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "control-label",
    attrs: {
      "for": "additionalmeal.time"
    }
  }, [_vm._v("Horário")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('##:##'),
      expression: "'##:##'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.additionalMeal.time),
      expression: "additionalMeal.time"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true,
          regex: /([01]\d|2[0-3]):([0-5]\d)/
        }
      }),
      expression: "{ rules: { required: true, regex: /([01]\\d|2[0-3]):([0-5]\\d)/} }"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Exemplo: 16:00",
      "id": "additionalmeal-time",
      "name": "additionalmeal-time"
    },
    domProps: {
      "value": (_vm.additionalMeal.time)
    },
    on: {
      "change": function($event) {
        _vm.completionStatus(_vm.additionalMeal)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.additionalMeal, "time", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6 col-xs-3",
    class: {
      'has-error': _vm.errors.has('additionalmeal-meal')
    }
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "control-label",
    attrs: {
      "for": "additionalmeal.meal"
    }
  }, [_vm._v("Alimento/Líquido")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.additionalMeal.meal),
      expression: "additionalMeal.meal"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Exemplo: Banana",
      "id": "additionalmeal-meal",
      "name": "additionalmeal-meal"
    },
    domProps: {
      "value": (_vm.additionalMeal.meal)
    },
    on: {
      "change": function($event) {
        _vm.completionStatus(_vm.additionalMeal)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.additionalMeal, "meal", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-2 col-xs-2",
    class: {
      'has-error': _vm.errors.has('additionalmeal-portion')
    }
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "control-label",
    attrs: {
      "for": "additionalmeal-portion"
    }
  }, [_vm._v("Quantidade")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.additionalMeal.portion),
      expression: "additionalMeal.portion"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Exemplo: 1",
      "id": "additionalmeal-portion",
      "name": "additionalmeal-portion"
    },
    domProps: {
      "value": (_vm.additionalMeal.portion)
    },
    on: {
      "change": function($event) {
        _vm.completionStatus(_vm.additionalMeal)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.additionalMeal, "portion", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-2 col-xs-2"
  }, [_c('button', {
    staticClass: "btn btn-block blue m-t-24",
    attrs: {
      "type": "submit",
      "disabled": _vm.errors.items.length > 0
    }
  }, [_c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Adicionar")])])])]), _vm._v(" "), (_vm.additionals && _vm.additionals.length > 0) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.additionals && _vm.additionals.length > 0) ? _c('div', {
    staticClass: "table-responsible"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Horário")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Alimento/Líquido")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Quantidade")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.additionals), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm._f("date")(item.time, 'HH:mm', true)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.meal))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.portion))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-info btn-xs",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.editAdditionalMealsItem(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-xs",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deleteAdditionalMealsItem(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  }))])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e81e6a14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./sources/domains/agenda/alimentation/meals/main.vue
// module id = 1117
// module chunks = 1